import { CLICK_PLANEJAMENTO_FILTER_BUTTON } from '../actions/actionTypes';

const initialState = {
    planejamentoFilter: {
        valueMaterial: [],
        valueNotMaterial: [],
        valueNotObservacao: [],
        valueNotCtZcos: [],
        valueEstoquePermanencia: [],
        valueMarca: [],
        valueFabrica: [],
        valueFabricaVersao: [],
        valueLinhaProduto: [],
        valueCategoriaProduto: [],
        valueColecao: [],
        valueTipoProdutoAcabado: {},
        valueDestinoConfeccao: [],
        valueQtdProgramadaManual: [],
        valueNo: [],
        valueObservacao: [],
        valueNivelRisco: [],
        valueNotNo: [],
        valueFabricaPreparacao: [],
        valueFabricaVersaoPreparacao: [],
        valuePercAnt: {},
        valueEstoqueSeguranca: {},
        valueNecessidadeCalculada: {},
        valueSaldoNegativo: {},
        valueTotalMinutos: {},
        valueQtdPrevisaoTotal: {},
        valueQtdProgramada: {},
        valueCoberturaEstoque: {},

        valueSaldoPositivo: {},
        valueSaldoCobertura: {},
        valueLoteMinimo: {},
        valueEstoqueInicial: {},
        valueQtdEstoqueProdPed: {},
        valuePercEstoqueSeg: {},
        valueQtdVenda: {},
        valueQtdPrevisao: {},
        valueRA: {},
        valueGuardar: {},
        valueGuardarCalculado: {},
        valueNecessidadeMultiplo: {},
        valueEstoqueFinal: {},
        valueEstoqueFinalFechamento: {},
        valueQtdAlocada: {},
        valueVendaDescoberta: {},
        valueSaldoDescasado: {},
        valueNaoPrograma: {},
        valueAplicouMI: {},
        valueFaixaOperacional: [],
        valueNotFaixaOperacional: [],
        valueLicenca: [],
        valueCliente: [],
        valueClienteEspecial: '',
        valueGrupoDeProduto: [],
        valueJustificativa: [],
        valueCtZcos: [],
    },
};

export const clickReducer = (state = initialState, action) => {
    switch (action.type) {
        case CLICK_PLANEJAMENTO_FILTER_BUTTON:
            const {
                valueMaterial,
                valueNotMaterial,
                valueNotObservacao,
                valueNotCtZcos,
                valueEstoquePermanencia,
                valueMarca,
                valueFabrica,
                valueFabricaVersao,
                valueLinhaProduto,
                valueCategoriaProduto,
                valueColecao,
                valueTipoProdutoAcabado,
                valueDestinoConfeccao,
                valueQtdProgramadaManual,
                valueNo,
                valueNotNo,
                valueFabricaPreparacao,
                valueFabricaVersaoPreparacao,
                valueObservacao,
                valueNivelRisco,
                valuePercAnt,
                valueEstoqueSeguranca,
                valueNecessidadeCalculada,
                valueSaldoNegativo,
                valueTotalMinutos,
                valueQtdPrevisaoTotal,
                valueQtdProgramada,
                valueCoberturaEstoque,
                valueSaldoPositivo,
                valueSaldoCobertura,
                valueLoteMinimo,
                valueEstoqueInicial,
                valueQtdEstoqueProdPed,
                valuePercEstoqueSeg,
                valueQtdVenda,
                valueQtdPrevisao,
                valueRA,
                valueGuardar,
                valueGuardarCalculado,
                valueNecessidadeMultiplo,
                valueEstoqueFinal,
                valueEstoqueFinalFechamento,
                valueQtdAlocada,
                valueVendaDescoberta,
                valueSaldoDescasado,
                valueNaoPrograma,
                valueAplicouMI,
                valueFaixaOperacional,
                valueNotFaixaOperacional,
                valueLicenca,
                valueCliente,
                valueClienteEspecial,
                valueGrupoDeProduto,
                valueJustificativa,
                valueCtZcos,
            } = action;
            return {
                ...state,
                planejamentoFilter: {
                    valueMaterial,
                    valueNotMaterial,
                    valueNotObservacao,
                    valueNotCtZcos,
                    valueEstoquePermanencia,
                    valueMarca,
                    valueFabrica,
                    valueFabricaVersao,
                    valueLinhaProduto,
                    valueCategoriaProduto,
                    valueColecao,
                    valueTipoProdutoAcabado,
                    valueDestinoConfeccao,
                    valueQtdProgramadaManual,
                    valueNo,
                    valueNotNo,
                    valueFabricaPreparacao,
                    valueFabricaVersaoPreparacao,
                    valueObservacao,
                    valueNivelRisco,
                    valuePercAnt,
                    valueEstoqueSeguranca,
                    valueNecessidadeCalculada,
                    valueSaldoNegativo,
                    valueTotalMinutos,
                    valueQtdPrevisaoTotal,
                    valueQtdProgramada,
                    valueCoberturaEstoque,
                    valueSaldoPositivo,
                    valueSaldoCobertura,
                    valueLoteMinimo,
                    valueEstoqueInicial,
                    valueQtdEstoqueProdPed,
                    valuePercEstoqueSeg,
                    valueQtdVenda,
                    valueQtdPrevisao,
                    valueRA,
                    valueGuardar,
                    valueGuardarCalculado,
                    valueNecessidadeMultiplo,
                    valueEstoqueFinal,
                    valueEstoqueFinalFechamento,
                    valueQtdAlocada,
                    valueVendaDescoberta,
                    valueSaldoDescasado,
                    valueNaoPrograma,
                    valueAplicouMI,
                    valueFaixaOperacional,
                    valueNotFaixaOperacional,
                    valueLicenca,
                    valueCliente,
                    valueClienteEspecial,
                    valueGrupoDeProduto,
                    valueJustificativa,
                    valueCtZcos,
                },
            };
        default:
            return state;
    }
};
